export default __webpack_public_path__ + "static/media/kyykka_2.c4d29bc8.png";